var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnChanges, OnInit } from '@angular/core';
import { ConfirmDialogComponent } from '../../../shared/dialog/confirm-dialog/confirm-dialog.component';
import CONST from '../get-number.type';
import { Store } from '@ngrx/store';
import { AmplitudeService } from '../../../shared/services/amplitude.service';
import { ConfigService } from '../../../config/config.service';
import { MatDialog, MatSort, MatTableDataSource } from '@angular/material';
import { getDocumentsSelector, getPricingSelector } from '../pricing-numbers.reducer';
import { AccountSettingsService } from '../../../my-account/account-settings.service';
import { InfoDialogComponent } from '../../../shared/dialog/info-dialog/info-dialog.component';
import { RegionForNumberChosenAction, SetAvailableNumberTypesAction } from '../pricing-numbers.action';
import { Router } from '@angular/router';
var PricingNumbersTableComponent = /** @class */ (function () {
    function PricingNumbersTableComponent(store, accountSettingsService, amplitudeService, configService, dialog, router) {
        this.store = store;
        this.accountSettingsService = accountSettingsService;
        this.amplitudeService = amplitudeService;
        this.configService = configService;
        this.dialog = dialog;
        this.router = router;
        this.displayedColumns = ['prefix', 'city', 'type', 'priceSetup', 'price', 'requiredDocumentsCodes', 'action'];
    }
    PricingNumbersTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.amplitudeService.logEvent('Panel:Numbers:Order: Init');
        this.loadPricing();
        this.setFilters();
        this.accountSettingsService.getSubscription().subscribe(function (subscription) {
            _this.isTrial = subscription.status === 'TRIAL';
        });
    };
    PricingNumbersTableComponent.prototype.ngOnChanges = function () {
        this.setFilters();
    };
    PricingNumbersTableComponent.prototype.getNumber = function (pricingItem) {
        var _this = this;
        if (this.isTrial && this.isFullyConfigured) {
            this.amplitudeService.logEvent('Panel:Numbers:Order Cannot order - trial');
            this.showCannotOrderNumberDueToTrialDialog().subscribe(function (confirm) {
                if (confirm) {
                    _this.amplitudeService.logEvent('Panel:Numbers:Order Cannot order - upgrade plan');
                    _this.router.navigateByUrl('/my-account');
                }
            });
            return;
        }
        if (!this.isFullyConfigured && !pricingItem.availableForInitialNumber) {
            this.amplitudeService.logEvent('Panel:Numbers:Order Cannot order initial number - number not available instantly', this.prepareNumberAmplitudeObject(pricingItem));
            this.showNotAvailableForInitialNumberDialog().subscribe();
            return;
        }
        this.amplitudeService.logEvent('Panel:Numbers:Order: City and prefix chosen', __assign({}, this.prepareNumberAmplitudeObject(pricingItem)));
        this.store.dispatch(new RegionForNumberChosenAction({
            fullyConfigured: this.isFullyConfigured,
            pricingId: pricingItem.id,
        }));
    };
    PricingNumbersTableComponent.prototype.loadPricing = function () {
        var _this = this;
        this.store.select(getPricingSelector).subscribe(function (pricing) {
            var availableNumberTypes = new Set();
            var updatedPricing = pricing.map(function (pricingItem) {
                availableNumberTypes.add(pricingItem.type);
                return __assign({}, pricingItem, { numberType: _this.getNumberType(pricingItem), buttonLabel: _this.getButtonLabel(pricingItem), hasRequiredDocuments: _this.hasRequiredDocuments(pricingItem) });
            });
            _this.dataSource = new MatTableDataSource(updatedPricing);
            setTimeout(function () {
                _this.setAvailableNumbersTypes(availableNumberTypes);
                _this.dataSource.sort = _this.sort;
                _this.dataSource.filterPredicate = function (data, filter) {
                    var filterObject = _this.filters;
                    var search = filterObject.search.trim().toLowerCase();
                    var type = filterObject.type;
                    var region = filterObject.region;
                    var isCorrectPrefix = data.prefix.toLowerCase().includes(search);
                    var isCorrectCity = data.city.toLowerCase().includes(search);
                    var isCorrectType = data.type.includes(type) || data.city.toLowerCase() === type.toLowerCase();
                    var isCorrectRegion = !region || data.region === region;
                    return (isCorrectPrefix || isCorrectCity) && isCorrectType && isCorrectRegion;
                };
            });
        });
        this.allPossibleDocuments$ = this.store.select(getDocumentsSelector);
    };
    PricingNumbersTableComponent.prototype.showCannotOrderNumberDueToTrialDialog = function () {
        return this.dialog
            .open(ConfirmDialogComponent, {
            data: {
                title: 'ORDER_NUMBER.TRIAL_MODAL.TITLE',
                body: 'ORDER_NUMBER.TRIAL_MODAL.TEXT',
                confirmButton: 'ORDER_NUMBER.TRIAL_MODAL.CONFIRM',
            },
        })
            .afterClosed();
    };
    PricingNumbersTableComponent.prototype.getButtonLabel = function (pricingItem) {
        return this.isFree(pricingItem) ? 'ORDER_NUMBER.GET_FREE' : 'ORDER_NUMBER.BUY';
    };
    PricingNumbersTableComponent.prototype.showNotAvailableForInitialNumberDialog = function () {
        return this.dialog
            .open(InfoDialogComponent, {
            data: {
                title: 'ORDER_NUMBER.NOT_AVAILABLE_FOR_INITIAL.TITLE',
                body: 'ORDER_NUMBER.NOT_AVAILABLE_FOR_INITIAL.BODY',
            },
        })
            .afterClosed();
    };
    PricingNumbersTableComponent.prototype.hasRequiredDocuments = function (pricingItem) {
        return !!pricingItem.requiredDocumentsCodes.length;
    };
    PricingNumbersTableComponent.prototype.getNumberType = function (pricingItem) {
        if (!pricingItem.availableToBuyWithoutSupport) {
            return CONST.TYPE.ORDER;
        }
        return CONST.TYPE.BUY;
    };
    PricingNumbersTableComponent.prototype.setFilters = function (filters) {
        var _this = this;
        if (filters === void 0) { filters = this.filters; }
        if (this.dataSource) {
            var newFiltersString = JSON.stringify(filters);
            var currentFiltersString = this.dataSource.filter;
            if (newFiltersString !== currentFiltersString) {
                setTimeout(function () {
                    _this.dataSource.filter = JSON.stringify(filters);
                });
            }
        }
    };
    PricingNumbersTableComponent.prototype.prepareNumberAmplitudeObject = function (pricingItem) {
        var availableToBuyWithoutSupport = pricingItem.availableToBuyWithoutSupport, city = pricingItem.city, countryCode = pricingItem.countryCode, prefix = pricingItem.prefix, numberType = pricingItem.numberType, price = pricingItem.price, priceSetup = pricingItem.priceSetup, requiredDocumentsCodes = pricingItem.requiredDocumentsCodes;
        return {
            availableToBuyWithoutSupport: availableToBuyWithoutSupport,
            city: city,
            countryCode: countryCode,
            prefix: prefix,
            numberType: numberType,
            priceMonthly: price,
            priceSetup: priceSetup,
            requiredDocumentsCodes: requiredDocumentsCodes,
        };
    };
    PricingNumbersTableComponent.prototype.isFree = function (element) {
        return !this.isFullyConfigured && element.availableForInitialNumber;
    };
    PricingNumbersTableComponent.prototype.setAvailableNumbersTypes = function (availableNumberTypes) {
        this.store.dispatch(new SetAvailableNumberTypesAction(Array.from(availableNumberTypes)));
    };
    return PricingNumbersTableComponent;
}());
export { PricingNumbersTableComponent };
